import { render } from "./NewsDetailSept2024Page.vue?vue&type=template&id=1cefeae3"
import script from "./NewsDetailSept2024Page.vue?vue&type=script&lang=js"
export * from "./NewsDetailSept2024Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__